import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Button Row",
  icon: "forms",
  tags: ["#subpage"],
  flags: {
    contentWidth: true,
  },
}

export default defineBlock("content/button-row", (props) => {
  return (
    <div className="flex flex-wrap gap-2 my-4">
      <InnerBlocks
        orientation="horizontal"
        adminClassName="w-full flex flex-wrap gap-2"
        allowedBlocks={["button"]}
        appender={{ type: "simple" }}
        defaultBlocks={[["content/button", {}]]}
      />
    </div>
  )
})
